import Cleave from 'cleave.js/react';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Col, Container, Form, Input, Row } from 'reactstrap';

const Contact = () => {
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            name: '',
            phone: '',
            question: ""
        },
        onSubmit: async (values) => {
            if (values.phone.length < 12) {
                toast.info(t('t-incorrect-phone'));

            } else {
                setLoading(true);
                let response = await fetch('https://online.hrplus.uz/send-advert-message', {
                    method: "POST",
                    headers: {
                        "Content-type": "application/json",
                        "login": 'HRplus+',
                        "password": 'Ctc0oTYayc77z'
                    },
                    body: JSON.stringify(values)
                })
                    .then(resp => resp.json())
                    .catch(err => {
                        console.log(err);
                    })
                    .finally(() => {
                        setLoading(false);
                    });

                if (!response['status'])
                    toast.error(t('t-server-error'));
                else {
                    toast.success(t('t-request-accepted2'));
                    validation.resetForm();
                }
            }
        }
    });


    return (
        <React.Fragment>
            <section className="section" id="contact">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div className="text-center mb-5">
                                <h3 className="mb-3 fw-semibold">
                                    {t('t-contact-us-head')}
                                </h3>
                                <p className="text-muted mb-4 ff-secondary">
                                    {t('t-contact-us-desc')}
                                </p>
                            </div>
                        </Col>
                    </Row>

                    <Row className="gy-4">
                        <Col lg={4}>
                            <div>
                                <div className="mt-4">
                                    <h5 className="fs-13 text-muted text-uppercase">
                                        {t('t-address')}:</h5>
                                    <div className="ff-secondary fw-semibold">
                                        {t('t-address-desc').split(",").map((item, idx) =>
                                            <span className='d-block' key={idx}>{item}{idx < t('t-address-desc').split(",").length - 1 ? ',' : ''}</span>)}
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <h5 className="fs-13 text-muted text-uppercase">
                                        {t('t-working-hours')}:</h5>
                                    <div className="ff-secondary fw-semibold">9:00 - 18:00</div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={8}>
                            <div>
                                <Form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        validation.handleSubmit();
                                        return false;
                                    }}
                                    className="needs-validation" action="#"
                                >
                                    <Row>
                                        <Col lg={6}>
                                            <div className="mb-4">
                                                <label htmlFor="name" className="form-label fs-13">
                                                    {t('t-name')} <span className="text-danger">*</span>
                                                </label>
                                                <Input
                                                    name="name"
                                                    id="name"
                                                    type="text"
                                                    className="form-control bg-light border-light"
                                                    placeholder={t('t-name-placeholder')}
                                                    onChange={validation.handleChange}
                                                    value={validation.values.name || ""}
                                                    required
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="mb-4">
                                                <label htmlFor="phone" className="form-label fs-13">
                                                    {t('t-phone')} <span className="text-danger">*</span>
                                                </label>
                                                <div className='input-group'>
                                                    <span className='input-group-text border-light'>+998</span>
                                                    <Cleave
                                                        id="phone"
                                                        options={{
                                                            blocks: [0, 2, 3, 2, 2],
                                                            delimiters: [' ', '-', '-'],
                                                            numericOnly: true
                                                        }}
                                                        name="phone"
                                                        type="text"
                                                        className="form-control bg-light border-light"
                                                        placeholder={t('t-phone-placeholder')}
                                                        onChange={validation.handleChange}
                                                        value={validation.values.phone || ""}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="mb-3">
                                                <label htmlFor="question" className="form-label fs-13">
                                                    {t('t-question')}
                                                </label>
                                                <textarea
                                                    name="question"
                                                    id="question"
                                                    rows="3"
                                                    className="form-control bg-light border-light"
                                                    placeholder={t('t-question-placeholder') + '...'}
                                                    onChange={validation.handleChange}
                                                    value={validation.values.question || ""}
                                                    required
                                                ></textarea>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12} className="text-end">
                                            <button type="submit" className="btn btn-warning" disabled={loading}>
                                                {t('t-send')} <i className="ri-send-plane-2-line fs-13 ms-1 align-bottom"></i>
                                            </button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Contact;